<template>
  <UiSelect
    :aria-label="t('order_title')"
    :design="props.design"
    :width="props.width"
    :model-value="params.order"
    @update:model-value="update('order', $event)"
  >
    <!--
    <template #icon>
      <UiIcon src="/svg/icons/location.svg" width="24" height="24" class="fill-neutral-500" />
    </template>
    -->
    <option value="relevanz" :selected="props.params.order === 'relevanz'">
      {{ t('order_option_relevance') }}
    </option>
    <option value="preis_aufsteigend" :selected="props.params.order === 'preis_aufsteigend'">
      {{ t('order_option_price_asc') }}
    </option>
    <option value="preis_absteigend" :selected="props.params.order === 'preis_absteigend'">
      {{ t('order_option_price_desc') }}
    </option>
    <option value="bewertung" :selected="props.params.order === 'bewertung'">
      {{ t('order_option_best_reviews_desc') }}
    </option>
    <!--
    <option value="bewertungen" :selected="params.order === 'bewertungen'">
      {{ t('order_option_most_reviews_desc') }}
    </option>
    <option value="sterne_absteigend" :selected="params.order === 'sterne_absteigend'">
      {{ t('order_option_stars_desc') }}
    </option>
    <option value="kalender" :selected="params.order === 'kalender'">
      {{ t('order_option_calendar') }}
    </option>
    -->
  </UiSelect>
</template>

<script setup>
const { translate: t } = useTranslations('SearchFilterSorting')

const emit = defineEmits(['update'])
const props = defineProps({
  params: {
    type: Object,
    default: () => ({})
  },
  design: {
    type: String,
    default: 'xs'
  },
  width: {
    type: String,
    default: 'w-full'
  }
})

const update = (key, val) => {
  emit('update', { [key]: val })
}
</script>
